"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractAsyncRelatedService = exports.AbstractRelatedService = void 0;
const front_core_1 = require("@movecloser/front-core");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let AbstractRelatedService = class AbstractRelatedService {
    constructor(drivers, record) {
        /**
         * Record of `RelatedTypeDrivers`.
         */
        this.drivers = {};
        /**
         * Record of all related data.
         */
        this.record = {};
        this.drivers = drivers;
        if (record) {
            this.record = record;
        }
    }
    describe(related) {
        const driver = this.resolveDriver(related.type);
        return driver.describe(`${related.value}`, this.record);
    }
    resetDrivers() {
        for (let i = 0; i < Object.values(this.drivers).length; i++) {
            const driver = Object.keys(this.drivers)[i];
            this.drivers[driver].reset();
        }
    }
    resolve(related, config) {
        if (typeof config === 'undefined') {
            config = {};
        }
        const driver = this.resolveDriver(related.type);
        return driver.resolve(`${related.value}`, this.record, config, this.resolveDriver.bind(this));
    }
    storeRelated(record) {
        for (const [key, value] of Object.entries(record)) {
            if (key in this.record && typeof this.record[key] !== 'undefined') {
                this.record[key] = { ...this.record[key], ...value };
            }
            else {
                this.record[key] = value;
            }
        }
    }
    /**
     * Resolves driver based on the passed-in `RelatedType`.
     *
     * @param type - `RelatedType` associated with the desired driver.
     */
    resolveDriver(type) {
        const found = this.drivers[type];
        if (typeof found === 'undefined') {
            throw new Error(`RelatedService.resolveDriver(): Unsupported related type [${type}] given.`);
        }
        return found;
    }
};
AbstractRelatedService = __decorate([
    front_core_1.Injectable(),
    __metadata("design:paramtypes", [Object, Object])
], AbstractRelatedService);
exports.AbstractRelatedService = AbstractRelatedService;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let AbstractAsyncRelatedService = class AbstractAsyncRelatedService {
    constructor(drivers, record) {
        /**
         * Record of `RelatedTypeDrivers`.
         */
        this.drivers = {};
        /**
         * Record of all related data.
         */
        this.record = {};
        this.drivers = drivers;
        if (record) {
            this.record = record;
        }
    }
    describe(related) {
        const driver = this.resolveDriver(related.type);
        try {
            const description = driver.describe(`${related.value}`, this.record);
            return Promise.resolve(description);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    resetDrivers() {
        for (let i = 0; i < Object.values(this.drivers).length; i++) {
            const driver = Object.keys(this.drivers)[i];
            this.drivers[driver].reset();
        }
    }
    resolve(related, config) {
        if (typeof config === 'undefined') {
            config = {};
        }
        const driver = this.resolveDriver(related.type);
        try {
            const description = driver.resolve(`${related.value}`, this.record, config, this.resolveDriver.bind(this));
            return Promise.resolve(description);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    storeRelated(record) {
        for (const [key, value] of Object.entries(record)) {
            if (key in this.record && typeof this.record[key] !== 'undefined') {
                this.record[key] = { ...this.record[key], ...value };
            }
            else {
                this.record[key] = value;
            }
        }
    }
    /**
     * Resolves driver based on the passed-in `RelatedType`.
     *
     * @param type - `RelatedType` associated with the desired driver.
     */
    resolveDriver(type) {
        const found = this.drivers[type];
        if (typeof found === 'undefined') {
            throw new Error(`RelatedService.resolveDriver(): Unsupported related type [${type}] given.`);
        }
        return found;
    }
};
AbstractAsyncRelatedService = __decorate([
    front_core_1.Injectable(),
    __metadata("design:paramtypes", [Object, Object])
], AbstractAsyncRelatedService);
exports.AbstractAsyncRelatedService = AbstractAsyncRelatedService;
//# sourceMappingURL=abstract.js.map